"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TreeSelect = TreeSelect;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TreeSelectComponent = require("./TreeSelectComponent");

var _Field = require("./Field");

var _excluded = ["cssClassModifiers", "errorMessage", "label"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function TreeSelect(props) {
  var cssClassModifiers = props.cssClassModifiers,
      errorMessage = props.errorMessage,
      label = props.label,
      remainingProps = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_Field.Field, {
    cssClassModifiers: cssClassModifiers,
    disabled: props.disabled,
    errorMessage: errorMessage,
    isValid: props.isValid,
    label: label
  }, /*#__PURE__*/_react["default"].createElement(_TreeSelectComponent.TreeSelectComponent, remainingProps));
}

TreeSelect.propTypes = {
  cssClassModifiers: _propTypes["default"].arrayOf(_propTypes["default"].string),
  disabled: _propTypes["default"].bool,
  errorMessage: _propTypes["default"].string,
  isValid: _propTypes["default"].bool,
  label: _propTypes["default"].string
};
TreeSelect.defaultProps = {
  cssClassModifiers: [],
  disabled: false,
  errorMessage: '',
  isValid: true,
  label: ''
};